module.exports = __webpack_public_path__ + "img/audio.effac262.svg";